import { z } from 'zod';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RecordAny = Record<string, any>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TodoAny = any;

export const preprocessEmptyStringAsNull = (val: unknown): unknown | null =>
	val === '' ? null : val;
export const preprocessEmptyStringAsUndefined = (val: unknown): unknown | undefined =>
	val === '' ? undefined : val;
export const optionalNullableInt = () =>
	z.preprocess(preprocessEmptyStringAsNull, z.number().int().nullable().optional());
